"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'password.reset.hero.title': 'Forgot Your Password?',
    'password.reset.hero.description': 'Don\'t worry, it happens to everyone. Enter your email address and we\'ll send you a link to reset your password.',
    'password.reset.hero.login_link_text': 'Remember your password?',
    'password.reset.hero.login_link': 'Sign in here',
    'password.reset.page.title': 'Password Reset',
    'password.reset.form.title': 'Reset Your Password',
    'password.reset.email.label': 'Email Address',
    'password.reset.email.placeholder': 'Enter your email address',
    'password.reset.submit': 'Send Reset Link',
    'password.reset.backToLogin': 'Back to Login',
    'password.reset.success.title': 'Email Sent!',
    'password.reset.success.description': 'Check your email for instructions on how to reset your password.',
    'password.reset.confirm.hero.title': 'Set New Password',
    'password.reset.confirm.hero.description': 'Create a strong password that you\'ll remember. Your new password should be different from your previous one.',
    'password.reset.confirm.hero.login_link_text': 'Remember your password?',
    'password.reset.confirm.hero.login_link': 'Sign in here',
    'password.reset.confirm.page.title': 'Set New Password',
    'password.reset.confirm.form.title': 'Create New Password',
    'password.reset.confirm.password.label': 'New Password',
    'password.reset.confirm.password.placeholder': 'Enter new password',
    'password.reset.confirm.confirmPassword.label': 'Confirm Password',
    'password.reset.confirm.confirmPassword.placeholder': 'Confirm new password',
    'password.reset.confirm.submit': 'Reset Password',
    'password.reset.confirm.success.title': 'Password Reset!',
    'password.reset.confirm.success.description': 'Your password has been reset successfully. You can now sign in with your new password.',
    'password.reset.confirm.mismatch': 'Passwords do not match',
    'password.reset.confirm.length': 'Password must be at least 6 characters long',
};
